const isVisible = ({ locations }, index) => {
  return locations.includes(index);
};

const Locations = {
  Path: {
    index: 0,
    name: () => "A Dusty Path",
    isVisible: isVisible,
    clickTarget: () => 0,
    selected: (location, index) => location === index,
  },
  Party: {
    index: 1,
    name: () => "The Party",
    isVisible: isVisible,
    clickTarget: () => 1,
    selected: (location, index) => location === index,
  },
  Road: {
    index: 2,
    name: () => "The Road",
    isVisible: isVisible,
    clickTarget: () => 2,
    selected: (location, index) => location === index,
  },
  City: {
    index: 3,
    name: (city) => city || "The City",
    isVisible: (phases, index, city) => isVisible(phases, index) && !!city,
    clickTarget: (city) => city,
    selected: (location, _, city) => {
      return location === city || (location === 3 && city !== null);
    },
  },
};

export default Locations;
